import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import Divider from "@mui/material/Divider";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import AppsIcon from "@mui/icons-material/Apps";
import AddIcon from "@mui/icons-material/Add";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import HomeIcon from "@mui/icons-material/Home";
import FolderIcon from "@mui/icons-material/Folder";
import SearchIcon from "@mui/icons-material/Search";
import ArticleIcon from "@mui/icons-material/Article";
import DomainIcon from "@mui/icons-material/Domain";
import NoteIcon from "@mui/icons-material/Note";
import MapIcon from "@mui/icons-material/Map";
import CalculateIcon from "@mui/icons-material/Calculate";
import PersonIcon from "@mui/icons-material/Person";
import ComputerIcon from "@mui/icons-material/Computer";
import ContactsIcon from "@mui/icons-material/Contacts";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Routes, Route, Link, Outlet } from "react-router-dom";
type DrawerProps = {
    open: boolean;
};

export default function DrawerContent(props: DrawerProps) {
    let open = props.open;
    return (
        <div>
            <List>
                <ListItem key={"Home"} disablePadding sx={{ display: "block" }}>
                    <Link to="/">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <AppsIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Home"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem
                    key={"PageAdd"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/page/edit">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <AddIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Home"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem key={"Page"} disablePadding sx={{ display: "block" }}>
                    <Link to="/page">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <ArticleIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Home"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"HomePage"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/page/view/114">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Home"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"Inbox"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/page/view/107">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <InboxIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Home"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"filter"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/filter/view/1">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <SearchIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"User"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem
                    key={"TicketPlus"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/ticket/edit">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <PlaylistAddIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Tickets"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"ListAlt"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/ticket">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Tickets"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"byDate"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/ticket/bydate">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <CalendarTodayIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"ByDate"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem
                    key={"byContext"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/ticket/byContext/2">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <DomainIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"ByDate"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"byContextComputer"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/ticket/byContext/4">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <ComputerIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"ByDate"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem key={"File"} disablePadding sx={{ display: "block" }}>
                    <Link to="/file/by-filter">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <FolderIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Note"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem key={"Note"} disablePadding sx={{ display: "block" }}>
                    <Link to="/note">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <NoteIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Note"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
            <Divider />
            <List>
                <ListItem
                    key={"Contacts"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/contact/">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <ContactsIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Counter"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem
                    key={"Counter"}
                    disablePadding
                    sx={{ display: "block" }}
                >
                    <Link to="/counter">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <CalculateIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Counter"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem key={"Map"} disablePadding sx={{ display: "block" }}>
                    <Link to="/map">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <MapIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"Counter"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
                <ListItem key={"User"} disablePadding sx={{ display: "block" }}>
                    <Link to="/user">
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : "auto",
                                    justifyContent: "center",
                                }}
                            >
                                <PersonIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary={"User"}
                                sx={{ opacity: open ? 1 : 0 }}
                            />
                        </ListItemButton>
                    </Link>
                </ListItem>
            </List>
        </div>
    );
}
